import { render, staticRenderFns } from "./text-input.vue?vue&type=template&id=4a34f839&"
import script from "./text-input.vue?vue&type=script&lang=js&"
export * from "./text-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports